import { render, staticRenderFns } from "./ProjectHeader.vue?vue&type=template&id=5aa72624&scoped=true"
import script from "./ProjectHeader.vue?vue&type=script&lang=js"
export * from "./ProjectHeader.vue?vue&type=script&lang=js"
import style0 from "./ProjectHeader.vue?vue&type=style&index=0&id=5aa72624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa72624",
  null
  
)

export default component.exports